// @flow

const fieldList = (fields: Array<ErrorFieldType> = []): string => {
  if (fields.length < 3) { return fields.join(' and '); }

  const others = fields.slice(0, -1);
  const tail = fields.slice(-1)[0];

  return others.join(', ') + ' and ' + tail;
};

type ErrorFieldType = string;

type PropsType = {
  errorFields: Array<ErrorFieldType>
};

export default ({ errorFields }: PropsType) => {
  if (!errorFields || errorFields.length === 0) { return null; }

  return (
    <div className='checkoutErrors'>
      Please enter a valid {fieldList(errorFields)}
    </div>
  );
};
